import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(date) {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
}

export function formatDateTime(date) {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function formatCurrency(amount, currency = 'EUR') {
  return new Intl.NumberFormat('en-EU', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2
  }).format(amount);
}

export function formatNumber(num) {
  return new Intl.NumberFormat('en-EU').format(num);
}

export function getStatusColor(status) {
  const colors = {
    active: 'status-success',
    completed: 'status-success',
    approved: 'status-success',
    qualified: 'status-success',
    compliant: 'status-success',
    paid: 'status-success',
    resolved: 'status-success',
    pending: 'status-warning',
    in_qualification: 'status-warning',
    pending_review: 'status-warning',
    under_review: 'status-warning',
    in_progress: 'status-warning',
    scheduled: 'status-info',
    confirmed: 'status-info',
    sent: 'status-info',
    new: 'status-info',
    rejected: 'status-error',
    expired: 'status-error',
    missed: 'status-error',
    suspended: 'status-error',
    non_compliant: 'status-error',
    overdue: 'status-error',
    critical: 'status-error',
    cancelled: 'status-error',
    draft: 'status-neutral',
    prospect: 'status-neutral',
    inactive: 'status-neutral',
    closed: 'status-neutral',
  };
  return colors[status?.toLowerCase()] || 'status-neutral';
}

export function getSeverityColor(severity) {
  const colors = {
    critical: 'bg-red-100 text-red-800 border-red-200',
    high: 'bg-orange-100 text-orange-800 border-orange-200',
    medium: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    low: 'bg-blue-100 text-blue-800 border-blue-200',
  };
  return colors[severity?.toLowerCase()] || colors.medium;
}

export function getExpiryStatus(date) {
  if (!date) return { status: 'unknown', text: 'No date' };
  const days = Math.ceil((new Date(date) - new Date()) / (1000 * 60 * 60 * 24));
  if (days < 0) return { status: 'expired', text: 'Expired' };
  if (days <= 7) return { status: 'critical', text: `${days} days` };
  if (days <= 30) return { status: 'warning', text: `${days} days` };
  if (days <= 90) return { status: 'upcoming', text: `${days} days` };
  return { status: 'ok', text: `${days} days` };
}

export const WASTE_STREAM_LABELS = {
  general: 'General Waste',
  cardboard: 'Cardboard / Paper',
  plastics: 'Plastics',
  glass: 'Glass',
  food: 'Food / Organic',
  weee: 'WEEE (Electronics)',
  hazardous: 'Hazardous',
  textiles: 'Textiles',
};

export const FREQUENCY_LABELS = {
  daily: 'Daily',
  weekly: 'Weekly',
  bi_weekly: 'Bi-Weekly',
  monthly: 'Monthly',
  custom: 'Custom',
};

export const COUNTRY_FLAGS = {
  AT: '🇦🇹',
  BE: '🇧🇪',
  BG: '🇧🇬',
  CH: '🇨🇭',
  CY: '🇨🇾',
  CZ: '🇨🇿',
  DE: '🇩🇪',
  DK: '🇩🇰',
  EE: '🇪🇪',
  ES: '🇪🇸',
  FI: '🇫🇮',
  FR: '🇫🇷',
  GB: '🇬🇧',
  GR: '🇬🇷',
  HR: '🇭🇷',
  HU: '🇭🇺',
  IE: '🇮🇪',
  IT: '🇮🇹',
  LT: '🇱🇹',
  LU: '🇱🇺',
  LV: '🇱🇻',
  MT: '🇲🇹',
  NL: '🇳🇱',
  NO: '🇳🇴',
  PL: '🇵🇱',
  PT: '🇵🇹',
  RO: '🇷🇴',
  SE: '🇸🇪',
  SI: '🇸🇮',
  SK: '🇸🇰',
};
